module.exports = __webpack_public_path__ + "img/mobile_map_collepardo.cda6ff6b.svg";